import React, { CSSProperties } from "react";

import clsx from "clsx";

import styles from "./Circle.module.scss";

export interface ICircleProps {
  radius?: number | string;
  className?: string;
  style?: CSSProperties;
}

export const Circle: React.FC<ICircleProps> = ({ radius = 36, className, style, children }) => {
  return (
    <div className={clsx(styles.base, className)} style={{ ...style, height: radius, width: radius }}>
      {children}
    </div>
  );
};
